import { Link } from "react-router-dom";
import { BillingPath } from "v2/pages/billing/BillingPath";
import { ReactComponent as SlowDownIcon } from "assets/icons/slow-down.svg";
import Button from "components/Button";
import { formatTimeHoursMins } from "components/hosted-scraping/project-summary/ProjectSummarySidebarHostedScraper";
import { JobInfoBox } from "components/hosted-scraping/job-list/JobInfoBox";


export const JobConcurrencyInfo = ({remainingTotalSeconds}: {remainingTotalSeconds: number | undefined}) => {
  const timeEstimate = remainingTotalSeconds ? formatTimeHoursMins(remainingTotalSeconds) : undefined;

  return (
    <JobInfoBox bgColor="bg-warning-50" borderColor="border-warning-200" className="flex-row items-start">
      <SlowDownIcon className="w-6 h-6 text-warning-600 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-2 flex-1 min-w-0">
        <div className="flex flex-row gap-2 justify-start text-neutral-900 w-64 text-sm">
          <div>Estimated run time:</div>
          <div><b>{timeEstimate ?? '-'}</b></div>
        </div>
        <div>
          <p className="text-base text-neutral-900 text-sm mb-2">
            This job runs on your plan's concurrency limits, the more threads available, the faster it runs.
          </p>
          <Link to={BillingPath}>
          <Button
            text="UPGRADE FOR FASTER RUNS"
            className="button button-secondary w-fit"
            size="SM"
          />
          </Link>
        </div>
      </div>
    </JobInfoBox>
  );
};
